module.exports = __webpack_public_path__ + "img/contacts_phone_big.47359901.svg";